var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopAlign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2874 15L18.2874 4.8L13.8874 4.8L13.8874 15C13.8874 15.1105 13.9769 15.2 14.0874 15.2L18.0874 15.2C18.1979 15.2 18.2874 15.1105 18.2874 15ZM19.0874 4L13.0874 4L13.0874 15C13.0874 15.5523 13.5351 16 14.0874 16L18.0874 16C18.6397 16 19.0874 15.5523 19.0874 15L19.0874 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2874 19L10.2874 4.8L5.8874 4.8L5.8874 19C5.8874 19.1105 5.97694 19.2 6.0874 19.2L10.0874 19.2C10.1979 19.2 10.2874 19.1105 10.2874 19ZM11.0874 4L5.0874 4L5.0874 19C5.0874 19.5523 5.53512 20 6.0874 20L10.0874 20C10.6397 20 11.0874 19.5523 11.0874 19L11.0874 4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4873 4.4C22.4873 4.62091 22.3082 4.8 22.0873 4.8H3.08731C2.86639 4.8 2.68731 4.62091 2.68731 4.4C2.68731 4.17909 2.86639 4 3.08731 4H22.0873C22.3082 4 22.4873 4.17909 22.4873 4.4Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopAlign);
export default __webpack_public_path__ + "static/media/topAlign.015990c07824cf10f6d2e23744e69f8b.svg";
export { ForwardRef as ReactComponent };